import React from "react";
import firstImage from "../assets/images/Main-banner-image.png";
import googlePlayStore from "../assets/images/Google-Play-Store.png";
import applerPlayStore from "../assets/images/Apple-Play-Store.png";

const firstPage = () => {
  return (
    <>
      <div className="container mx-auto flex flex-col items-center text-center sm:flex-row sm:justify-between px-4 py-8 md:py-0 mt-[70px] md:mt-[10px] mainbanner-class">
        <div className="flex flex-col items-center sm:flex-row sm:justify-center sm:mt-0 first-img sm:mb-0 sm:order-1 order-2 -mb-10">
          <img
            src={firstImage}
            alt="Illustration"
            className="w-[300px] h-[280px] sm:w-[450px] sm:h-[415px] md:w-[575px] md:h-[554px] md:-ml-[10%] sm:ml-0 custom-img"
          />
        </div>
        <div className="w-full sm:w-1/3 text-center sm:text-left sm:-mt-24 main-block mb-0 sm:mb-0 sm:order-2 order-1">
          <p className="text-2xl sm:text-3xl lg:text-3xl font-bold">
            <span className="text-[#E53A36] font-bold text-2xl md:text-3xl lg:text-3xl responsive-text-size">
              Track.
            </span>
            <span className="text-[#1380E7] font-bold text-2xl md:text-3xl lg:text-3xl responsive-text-size">
              Expense.
            </span>
            <span className="text-[#009852] font-bold text-2xl md:text-3xl lg:text-3xl responsive-text-size">
              Budget.
            </span>
            <br />
          </p>
          <p className="mt-5">
            <span className="font-bold sm:text-xl md:text-[20px] lg:text-xl block sm:inline whitespace-nowrap sm:mb-0 -mb-6 responsive-text">
              Smartspend Expense Manager:
            </span>
            <br />
            <span className="font-medium text-[15px] sm:text-lg md:text-xl responsive-text">
              Your Daily Companion for Financial Success.
            </span>
          </p>

          <div className="flex mt-4 justify-center sm:justify-start">
            <div className="inline-block mr-2">
              <a
                href="https://play.google.com/store/apps/details?id=sstech.com.smartspend"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={googlePlayStore}
                  alt="Google Play Store"
                  className="h-[35px] w-[120px] sm:h-[55px] sm:w-[170px]"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default firstPage;
